import { Link } from "react-router-dom";
import { ShoppingBag, Heart } from "lucide-react";
import { formatTL } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const discount =
    product.old_price && product.old_price > product.price
      ? Math.round(((product.old_price - product.price) / product.old_price) * 100)
      : 0;

  return (
    <div className="product-card group" data-testid={`product-card-${product.slug}`}>
      <Link to={`/urun/${product.slug}`} className="block relative overflow-hidden">
        <div className="aspect-square overflow-hidden bg-[#F4F7F9]">
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        {discount > 0 && (
          <span className="absolute top-3 left-3 bg-[#E9C46A] text-[#0A192F] text-[10px] font-extrabold tracking-wider px-2.5 py-1 rounded-full">
            %{discount} İNDİRİM
          </span>
        )}
        {product.is_featured && (
          <span className="absolute top-3 right-3 bg-white/90 backdrop-blur text-[#0077B6] text-[10px] font-extrabold tracking-wider px-2.5 py-1 rounded-full">
            GÜNLÜK TAZE
          </span>
        )}
      </Link>
      <div className="p-5 space-y-3">
        <Link to={`/urun/${product.slug}`}>
          <h3 className="font-display text-lg font-bold leading-tight text-[#0A192F] hover:text-[#0077B6] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-end gap-2">
          <span data-testid={`product-price-${product.slug}`} className="text-2xl font-display font-extrabold text-[#0077B6]">
            {formatTL(product.price)}
          </span>
          {product.old_price && product.old_price > product.price && (
            <span className="text-sm text-slate-400 line-through pb-0.5">{formatTL(product.old_price)}</span>
          )}
        </div>
        <div className="flex items-center gap-2 pt-1">
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={() => addItem(product, 1)}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#0077B6] px-4 py-2.5 text-white text-sm font-semibold hover:bg-[#005a8c] transition-colors"
          >
            <ShoppingBag size={15} /> Sepete Ekle
          </button>
          <Link
            to={`/urun/${product.slug}`}
            className="rounded-full border-2 border-slate-200 px-3 py-2.5 text-[#0A192F] hover:border-[#0077B6] hover:text-[#0077B6] transition-colors"
            aria-label="Detay"
          >
            <Heart size={15} />
          </Link>
        </div>
        {product.stock > 0 ? (
          <div className="text-[11px] text-emerald-700 font-semibold">● Stokta · Bugün kargoda</div>
        ) : (
          <div className="text-[11px] text-rose-600 font-semibold">● Stok Tükendi</div>
        )}
      </div>
    </div>
  );
}
